
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function searchInputIn(toSearchIn, input) {
    const escapedInput = escapeRegexCharacters(input);
    const stockMatchRegex = new RegExp('\\b' + escapedInput, 'i');

    const firstMatchIndex = toSearchIn.search(stockMatchRegex);
    if (firstMatchIndex === -1) {
        return {
            beforeMatch: toSearchIn,
            match: "",
            afterMatch: ""
        };
    }

    return {
        beforeMatch: toSearchIn.slice(0, firstMatchIndex),
        match: toSearchIn.slice(firstMatchIndex, firstMatchIndex + input.length),
        afterMatch: toSearchIn.slice(firstMatchIndex + input.length)
    };
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/searchTerms.js
 **/